"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$id = void 0;
var $id = function (name) {
    return "http://stratumn.com/schemas/dsl/" + name + ".json";
};
exports.$id = $id;
//# sourceMappingURL=jsonschema.js.map